import { useIsMobile } from '../../hook/useIsMobile';
import { NumberTicketPc } from './NumberTicket/NumberTicket.pc';
import { NumberTicketMobile } from './NumberTicket/NumberTicket.mobile';

export const NumberTicket = ({ cnt }: { cnt: number }) => {
  const isMobile = useIsMobile();
  return isMobile ? <NumberTicketMobile cnt={cnt} /> : <NumberTicketPc cnt={cnt} />;
};
